<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import type { SbColor } from '../types';
	import { editable } from '../editable';

	type AttributeColor = Extract<SbColor, 'brown-1' | 'green-2'>;

	interface Props {
		content: ISbStoryData<{
			attributeAColor: AttributeColor;
			attributeATitle: string;
			attributeASubtitle: string;
			attributeBColor: AttributeColor;
			attributeBTitle: string;
			attributeBSubtitle: string;
		}>['content'];
	}

	let { content }: Props = $props();

	let attributeAColor = $derived(content.attributeAColor || 'brown-1');
	let attributeBColor = $derived(content.attributeBColor || 'green-2');
</script>

<section use:editable={content}>
	<div class="grid grid-cols-4 gap-x-6 lg:grid-cols-12">
		<div
			class="col-span-2 py-6 pl-4 pr-[10px] lg:col-span-6 lg:py-7 lg:pl-6 lg:pr-[18px] xl:col-start-3 xl:col-end-7"
		>
			<p
				class="text-[18px]/[110%] font-semibold lg:text-[24px] text-{attributeAColor} text-balance"
			>
				{content.attributeATitle}
			</p>
			<p class="mt-2 text-balance text-[16px]/[140%] text-brown-3 lg:text-[18px]">
				{content.attributeASubtitle}
			</p>
		</div>
		<div class="col-span-2 py-6 pr-4 lg:col-span-6 lg:py-7 xl:col-start-7 xl:col-end-11">
			<p class="text-[18px]/[110%] font-semibold lg:text-[24px] text-{attributeBColor}">
				{content.attributeBTitle}
			</p>
			<p class="mt-2 text-balance text-[16px]/[140%] text-brown-3 lg:text-[18px]">
				{content.attributeBSubtitle}
			</p>
		</div>
	</div>
</section>
